<app-header></app-header>
<div class="home-main">
  <div class="sidebar">
    <app-sidebar (headingEvent)="receiveHeading($event)" (toggleSidebarEvent)="receiveSidebarEvent($event)" />
  </div>

  <div class="news_categories_page" [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'">
    <!-- Header/Breadcrumb -->
    <div class="bg_1 p-x-40 p-y-17 dis_flex font_13 weight_600">
      <div
        class="dis_flex align_center color_blue cursor_pointer"
        (click)="navigateBack()"
      >
        Back to Discovery Updates
      </div>
      <div class="dis_flex align_center p-x-16">
        <svg
          width="7"
          height="8"
          viewBox="0 0 7 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030"
          />
        </svg>
      </div>
      <div class="dis_flex align_center">All Categories</div>
    </div>

    <!-- Main Content -->
    <div class="categories_container p-40">
      <div class="color_black font_28 weight_700 p-bot-20">
        {{ databaseName === 'SPC' ? 'SPC' : 'Discovery Suite' }} Database Categories
      </div>

      <!-- Categories List -->
      <div *ngIf="categories.length; else noCategories">
        <ng-container *ngFor="let category of categories">
          <div class="category_card bg_1 border-radius-12 p-24 m-bot-20">
            <!-- Category Header -->
            <div class="dis_flex jc_space_bet align_items_center">
              <div>
                <div class="color_black font_20 weight_700">
                  {{ category.name }}
                </div>
                <div
                  class="color_gray font_14 weight_500 p-top-8"
                  *ngIf="category.description"
                >
                  {{ category.description }}
                </div>
                <div class="color_gray font_12 weight_500 p-top-4">
                  {{ category.subcategories.length }} subcategories
                </div>
              </div>
              <div class="dis_flex gap_16">
                <button
                  class="btn_primary p-x-20 p-y-10 border-radius-8 cursor_pointer"
                  (click)="goToCategoryNews(category._id)"
                >
                  View News
                </button>
                <button
                  class="btn_secondary p-x-20 p-y-10 border-radius-8 cursor_pointer"
                  (click)="toggleCategory(category)"
                  *ngIf="category.subcategories.length"
                >
                  {{ category.expanded ? "Hide" : "Show" }} Subcategories
                </button>
              </div>
            </div>

            <!-- Subcategories (Expandable) -->
            <div
              class="subcategories_list p-top-20"
              *ngIf="category.expanded && category.subcategories.length"
            >
              <div class="border_top_gray p-top-20">
                <div class="color_black font_16 weight_600 p-bot-12">
                  Subcategories:
                </div>
                <div class="dis_flex flex_wrap gap_12">
                  <ng-container
                    *ngFor="let subcategory of category.subcategories"
                  >
                    <div
                      class="subcategory_chip bg_white border_gray p-x-16 p-y-8 border-radius-20 cursor_pointer hover_blue"
                      (click)="goToSubcategoryNews(subcategory._id)"
                    >
                      <div class="dis_flex align_items_center gap_8">
                        <div class="color_black font_14 weight_500">
                          {{ subcategory.name }}
                        </div>
                        <svg
                          width="10"
                          height="10"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.1117 5.99274L4.3265 0.207681C4.19269 0.0737718 4.01408 0 3.82362 0C3.63317 0 3.45455 0.0737718 3.32075 0.207681L2.89471 0.633613C2.61749 0.911155 2.61749 1.36224 2.89471 1.63936L7.75266 6.4973L2.88932 11.3606C2.75552 11.4945 2.68164 11.6731 2.68164 11.8634C2.68164 12.054 2.75552 12.2325 2.88932 12.3665L3.31536 12.7923C3.44927 12.9262 3.62778 13 3.81823 13C4.00869 13 4.1873 12.9262 4.32111 12.7923L10.1117 7.00198C10.2458 6.86764 10.3194 6.68829 10.319 6.49762C10.3194 6.30622 10.2458 6.12697 10.1117 5.99274Z"
                            fill="#0032A0"
                          />
                        </svg>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- No Categories Message -->
      <ng-template #noCategories>
        <div class="no_data p-40 text_center">
          <div class="color_gray font_18 weight_500">
            No categories found for Discovery Suite database
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- <div class="news_category_body">
  <div class="row">
 
    <div class="col-8">
      <ng-container *ngIf="showNews">
        <ng-container *ngFor="let category of categoryList">
          <div class="col-4" *ngIf="newsCategoryData[category._id]">
            <div class="news-category-sec-col">
              <div class="row news-category-sec-col-category">
                <div class="col-8">
                  <p class="news-category-sec-col-category-title">{{category.name | titlecase}}</p>
                </div>
                <div class="col-4">
                  <a class="news-category-sec-col-category-link" routerLink="/news/category/{{category._id}}">Show All</a>
                </div>            
              </div>
              <ng-container *ngFor="let news of newsCategoryData[category._id]; let i =index">
                {{i}}
                <div class="row news-category-sec-col-top" *ngIf="i===0">
                  <div class="col-12">
                    <div class="news-category-sec-col-top-item" (click)="goToNewsDetail(news.slug || news._id)">
                      <img [src]="filePath+news.thumbnail_image" class="news-category-sec-col-top-item-img" alt="Image">
                      <div class="news-category-sec-col-top-item-body">
                        <p class="news-category-sec-col-top-item-body-details">{{news.news_date|date}}</p>
                        <p class="news-category-sec-col-top-item-body-title">{{news.title}}</p>
                      </div>              
                    </div>
                  </div>              
                </div>
                <div class="row ml-0" *ngIf="i!==0">              
                  <div class="col-12">
                    <ul class="list-group">
                      <li class="list-group-item news-category-sec-col-item border-right-0 border-left-0 px-0" [ngClass]="i!==1?'border-top-0':''">
                        <div class="row news-category-sec-col-item-body" (click)="goToNewsDetail(news.slug || news._id)">
                          <img [src]="filePath+news.thumbnail_image" class="col-3 news-category-sec-col-item-body-img" alt="Image">
                          <div class="col-9">
                            <p class="news-category-sec-col-item-body-details">{{news.news_date|date}}</p>
                            <p class="news-category-sec-col-item-body-title">{{news.title}}</p>
                          </div>                
                        </div>              
                      </li>          
                    </ul>
                  </div>
                </div>                                   
              </ng-container>
            </div>                
          </div>  
        </ng-container>
      </ng-container>
    </div>

   
    <div class="col-4">
      <div class="news_category_body_title">Categories</div>
      <div class="news_category_body_list">
        <ul class="pl-0" style="list-style-type: none;">
          <ng-container *ngFor="let category of categoryList">
            <li class="news_category_body_list_item">
              <a [routerLink]="['/news/Categories', category._id]" (click)="onCategoryClick(category._id)"
                style="cursor: pointer; text-decoration: none;">
                {{ category.name }}
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div> -->

<app-footer></app-footer>
